import { toNumber } from "lodash";
import React, { useEffect, useState } from "react";
import LineChart from "../../shared/components/LineChart/LineChart";
import sensorIcon from '../../assets/Images/sensor32.png';
import backIcon from '../../assets/Images/Back_16.png';
import { FormattedMessage, injectIntl } from "react-intl";
import { formatMessage } from "../../translations/connectedIntlProvider";
import RoutesConstants from "../../shared/components/Routes/routes.constants";
import { useDispatch, useSelector } from "react-redux";
import IState from "../../core/models/IState";
import * as actions from '../../core/actions/actions';
import { DataPoint, initOptions } from "./IAQSensorDataLineChart.type";
import moment from "moment";
import config from '../../helpers/config.helper';
import modelEnum from "../../constants/model.enum";
import userSettingEnum from "../../constants/userSetting.enum";
import IAQChartSetting from "./IAQChartSetting";
import IAQChartSettingPopupHOC from "./hoc/IAQChartSettingPopupHOC";
import './IAQSensorDataLineChart.css';
import { allIAQSensorDataChart } from "../../core/selectors/iaqSensorDataChart.selector";
import AddIAQSensorColumnPopupHOC from "../IAQSensorData/hoc/AddIAQSensorColumnPopupHOC";
import AddIAQSensorColumn from "../IAQSensorData/IAQAddSensorColumn";
import ChartSkeleton from "./components/ChartSkeleton";
import { ILegendDetailsVM } from "../../core/models/IIAQDevicesState";
import { toast } from "react-toastify";
import noData from '../../assets/Images/no_data.svg';
import { insertBreakPoints } from "../../helpers/utility.helper";
import { sensorConfigJSONData } from "../../core/reducers/data";
import { convertLocalToUTC, getYAxisInterval } from "../../constants/common.constant";

const appConfig = config();
const dateFormat = appConfig.REACT_APP_DATE_FORMAT;
const dateTimeFormat = appConfig.REACT_APP_DATE_TIME_FORMAT;

const CHART_BG = "#0d1117";
const CHART_LINE_COLOR = "#00e5ff";
const CHART_MARKER_COLOR = "#00e5ff";
const AXIS_LABEL_COLOR = "#ffffff";
const TITLE_COLOR = "#ffffff";
const GRID_COLOR = "rgba(255,255,255,0.12)";
const AXIS_LINE_COLOR = "rgba(255,255,255,0.25)";
const TOOLTIP_BG = "#1e2a44";

const IAQSensorDataLineChart = (props: any) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  const dispatch = useDispatch();

  const { sensorDataChartList }: any = useSelector((state: IState) => {
    return state.iaqSensorDataChart
  });
  const { columnLists, dataRange }: any = useSelector((state: IState) => {
    return state.column
  });
  const { language, isLanguageChanged } = useSelector((state: IState) => {
    return state.preferences
  })
  const allChartSensorData: any = useSelector(allIAQSensorDataChart);
  const [charts, setCharts] = useState<any>([]);
  const [dataRangeFlag, setDataRangeFlag] = useState<boolean>(false);
  const [columnListFlag, setColumnListFlag] = useState<boolean>(false);
  const [range, setRange] = useState<any>();
  const [EndDate, setEndDate] = useState<any>();
  const [endDateDisabled, setEndDateDisabled] = useState(false);
  const [chartKey, setChartKey] = useState<number>(0);
  const [durationInfo, setDurationInfo] = useState<any>({
    range: null,
    startDate: null,
    endDate: null
  })

  let chartPostData: any = {
    ICCID: '',
    Model: 0,
    KPIs: [],
    StartDate: '',
    EndDate: ''
  };

  const model = props.location.state ? props.location.state.model : '';
  const iccid = props.location.state ? props.location.state.iccid : '';
  const customerId = props.location.state ? props.location.state.customerId : '';
  const fromPath = props.location.state ? props.location.state.fromPath : RoutesConstants.IAQRealTimeView;


  const handleDuration = (range: any, startDate: string, endDate: string) => {
    setDurationInfo({
      range: range == 1 ? "Day" : ((range == 7 ? "Week" : "Month")),
      startDate: moment(startDate).format(dateFormat) + " 00:00",
      endDate: moment(endDate).format(dateFormat) + " 23:59"
    });
  };

  const GetChartData = (date: any, range: any, isTillDate: boolean) => {
    var endDate = new Date();
    if (isTillDate === false) endDate = date;
    var newDate = new Date(endDate);
    // Added 1 to get the exact number of days no more
    newDate.setDate(newDate.getDate() - toNumber(range));
    chartPostData.ICCID = iccid;
    chartPostData.Model = model;
    chartPostData.KPIs = columnLists.columns !== undefined
      ? (columnLists.columns.Value ? JSON.parse(columnLists.columns.Value) : [])
      : [];
    if(chartPostData?.KPIs.length === 0 ) return;
    let endDateLocal: string = moment(endDate).format(dateFormat) + " 23:59:59";
    let startDateLocal: string = moment(newDate).format(dateFormat) + " 00:00:00";
    chartPostData.EndDate = convertLocalToUTC(endDateLocal); //converted Local date time to UTC
    chartPostData.StartDate = convertLocalToUTC(startDateLocal); ////converted Local date time to UTC
    
    dispatch(actions.getIAQSensorDataChart(chartPostData));
    handleDuration(range, startDateLocal, endDateLocal)
  }

  const GetLineChartColumns = () => {
    dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnIAQ));
  }

  const GetDataRange = () => {
    dispatch(actions.getDataRange(userSettingEnum.DataRangeIAQ));
  }


  const observerRef = React.useRef<MutationObserver | null>(null);

  useEffect(() => {
    observerRef.current = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          const el = node as HTMLElement;

          if (
            el.style?.position === "absolute" &&
            el.children.length >= 2 &&
            el.children[0]?.textContent?.trim() &&
            ["Print", "Save as JPEG", "Save as PNG",
              "画像保存", "印刷"].some(t =>
                Array.from(el.children).some(c => c.textContent?.includes(t))
              )
          ) {
            Object.assign(el.style, {
              background: "#0d1117",
              border: "1px solid rgba(0,229,255,0.35)",
              borderRadius: "8px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.7), 0 0 0 1px rgba(0,229,255,0.08)",
              padding: "4px",
              overflow: "hidden",
            });

            Array.from(el.children).forEach((child) => {
              const item = child as HTMLElement;
              Object.assign(item.style, {
                background: "transparent",
                color: "#e2e8f0",
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "13px",
                padding: "8px 16px",
                borderRadius: "5px",
                cursor: "pointer",
              });

              item.addEventListener("mouseenter", () => {
                item.style.background = "rgba(0,229,255,0.15)";
                item.style.color = "#00e5ff";
              });
              item.addEventListener("mouseleave", () => {
                item.style.background = "transparent";
                item.style.color = "#e2e8f0";
              });
            });
          }
        });
      });
    });

    observerRef.current.observe(document.body, { childList: true });

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  useEffect(() => {
    dispatch(actions.resetUserSettingState());
    dispatch(actions.resetDataRangeState());
    GetLineChartColumns();
    return (() => {
      setRange(undefined);
      setEndDate(undefined);
      setEndDateDisabled(false);
      // dispatch(actions.resetIAQLegendDetailsState());
      dispatch(actions.resetGetIAQSensorDataChartState());
      dispatch(actions.resetUserSettingState());
    });
  }, []);

  useEffect(() => {
    if (isLanguageChanged) {
      refreshChartClickHandler();
      dispatch(actions.resetIsLanguageChanged());

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLanguageChanged]);

  useEffect(() => {
    if (columnLists.success) {
      if (columnLists.columns === "") setColumnListFlag(true);
      GetDataRange();
      // dispatch(actions.resetUserSettingSuccessState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnLists.success]);

  useEffect(() => {
    if (dataRange.success) {
      if (dataRange.data === "") setDataRangeFlag(true);
      if (dataRange.data.Value) {
        var rangeData = JSON.parse(dataRange.data.Value);
        setRange(rangeData.range);
        setEndDate(rangeData.EndDate);
        setEndDateDisabled(rangeData.isTillDate);
        GetChartData(rangeData.EndDate, rangeData.range, rangeData.isTillDate);
      }
      setCharts([]);
      dispatch(actions.resetDataRangeState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRange.success]);

  useEffect(() => {
    if (sensorDataChartList.error) {
      toast.error(formatMessage(sensorDataChartList.error))
      dispatch(actions.resetGetIAQSensorDataChartState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sensorDataChartList.error]);

  const getModePrefix = () => {
    return modelEnum.IAQ.toLowerCase();
  }

  const getSensorRange = (name: string) => {
    const sensor = sensorConfigJSONData.find(
      (item: ILegendDetailsVM) => item.KPI.toLowerCase() === name.toLowerCase()
    );
    return sensor
      ? { MinRange: sensor?.MinValue, MaxRange: sensor?.MaxValue }
      : { MinRange: 0, MaxRange: 100 };
  };

  const createChart = () => {
    if (!allChartSensorData?.ChartData) return;

    const xAxisInterval = getXAxisLabelInterval(1, range);
    const modePrefix = getModePrefix();
    const chartHeight = allChartSensorData.ChartData.length > 2 ? 260 : 550;

    let numberOfDays = typeof range === "string" ? parseInt(range) : 0;
    const chartsData = allChartSensorData.ChartData.map((element: any) => {
      const dataPoints: any[] = insertBreakPoints(element.Data, numberOfDays > 7 ? 60 : 6).map((d: any) => ({
        x: d.x,
        y: d.y,
      }));

      const xValues = dataPoints.map((d: any) => d.x.getTime());
      const sensorRange = getSensorRange(element.KPIName);
      const minX = new Date(xValues[0]);
      const maxX = new Date(xValues[xValues.length - 1]);
      let minY = sensorRange.MinRange;
      let maxY = sensorRange.MaxRange;

      return {
        ...initOptions,
        height: chartHeight,

        backgroundColor: CHART_BG,
        theme: "dark2",
        exportEnabled: true,
        zoomEnabled: true,
        animationEnabled: true,
        interactivityEnabled: true,
        title: {
          ...initOptions.title,
          text: formatMessage(modePrefix + element.KPIName),
          fontColor: TITLE_COLOR,
          fontSize: 16,
          fontWeight: "bold",
          fontFamily: "Segoe UI, Roboto, sans-serif",
          padding: { top: 12, bottom: 8 },
        },
        axisX: {
          ...initOptions.axisX,
          minimum: minX,
          maximum: maxX,
          interval: xAxisInterval,
          intervalType: 'day',
          valueFormatString: "DD-MMM",
          labelFontColor: AXIS_LABEL_COLOR,
          labelFontSize: 12,
          labelFontFamily: "Segoe UI, sans-serif",
          labelFontWeight: "bold",
          lineColor: AXIS_LINE_COLOR,
          tickColor: AXIS_LINE_COLOR,
          lineThickness: 1,
          tickLength: 5,
          gridColor: GRID_COLOR,
          gridThickness: 1,
          gridDashType: "solid",
          crosshair: {
            enabled: true,
            snapToDataPoint: true,
            lineDashType: "dash",
            color: "#2cd6e8",
            thickness: 2,
            opacity: 1,
            labelFormatter: () => "",
          },
        },
        axisY: {
          ...initOptions.axisY,
          title: formatMessage(element.KPIUnit),
          minimum: minY,
          maximum: maxY,
          titleFontColor: AXIS_LABEL_COLOR,
          titleFontSize: 13,
          titleFontFamily: "Segoe UI, sans-serif",
          titleFontWeight: "bold",
          labelFontColor: AXIS_LABEL_COLOR,
          labelFontSize: 12,
          labelFontFamily: "Segoe UI, sans-serif",
          labelFontWeight: "bold",
          lineColor: AXIS_LINE_COLOR,
          tickColor: AXIS_LINE_COLOR,
          lineThickness: 1,
          tickLength: 5,
          gridColor: GRID_COLOR,
          gridThickness: 1,
          gridDashType: "solid",
          interval: getYAxisInterval(minY, maxY),
        },

        toolTip: {
          backgroundColor: TOOLTIP_BG,
          fontColor: "#000",
          borderColor: CHART_LINE_COLOR,
          borderThickness: 1,
          cornerRadius: 6,
          fontFamily: "Segoe UI, sans-serif",
          fontSize: 13,
          fontWeight: "bold",
          content: "{x}<br/>{name}: {y}"
        },

        data: [
          {
            ...initOptions.data[0],
            type: "spline", 
            color: CHART_LINE_COLOR,
            lineThickness: 2,
            markerType: "circle",
            markerColor: CHART_MARKER_COLOR,
            markerBorderColor: CHART_BG,
            markerBorderThickness: 0,
            markerSize: 3, 
            highlightEnabled: true,
            name: formatMessage(modePrefix + element.KPIName),
            xValueFormatString: dateTimeFormat,
            dataPoints,
          },
        ],

        culture: language === "en" ? "en" : "jp",
      };
    });

    setCharts(chartsData);
  };

  useEffect(() => {
    if (sensorDataChartList.success) {
      setColumnListFlag(false);
      setDataRangeFlag(false);
      setChartKey(prev => prev + 1);
      createChart();
      dispatch(actions.resetGetIAQSensorDataChartSuccessState());

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }
  }, [sensorDataChartList.success]);

  const getXAxisLabelInterval = (chartCount: number, range: String) => {
        if (chartCount > 0) { //Handle the case when we have 2 charts
            var days = Number(range);
            if (!isNaN(days)) {
                return Math.ceil(days / 15);
            }
        }
        return 2;
    }

  const refreshChartClickHandler = () => {
     let tempKPIs = columnLists.columns !== undefined
      ? (columnLists.columns.Value ? JSON.parse(columnLists.columns.Value) : [])
      : [];
    if(tempKPIs.length == 0) return;
    setCharts([]);
    if (!(EndDate === undefined || range === undefined))
      GetChartData(EndDate, range, endDateDisabled);
    // dispatch(actions.getIAQLegendDetails());
  }

  const backToSensorDataHandler = () => {
    dispatch(actions.resetUserSettingState());
    dispatch(actions.resetGetIAQSensorDataChartState());
    props.history.push({
      pathname: fromPath,
      state: {
        iccid: iccid,
        model: model,
        building: props.location.state.building,
        location: props.location.state.location,
        floor: props.location.state.floor,
        customerId: props.location.state.customerId,
        room: props.location.state.room,
        latestPayloadTime: props.location.state?.latestPayloadTime,
        fromParentPath: props.location.state?.fromParentPath
      }
    });
  }

  const openChartSetting = () => {
    props.chartSettingToggleHandler();
  }

  const openAddColumn = () => {
    props.addSensorColumToggleHandler();
  }

  const onColumnSave = () => {
    GetLineChartColumns();
  }

  const onDataSave = (values: any) => {
    if (values) {
      setRange(values.range);
      setEndDate(values.EndDate);
      setEndDateDisabled(values.isTillDate);
      if (columnLists.columns !== "") GetChartData(values.EndDate, values.range, values.isTillDate);
    }
  }
  return (
    <React.Fragment>
      {props.showChartSettingPopup &&
        <IAQChartSetting
          range={range}
          EndDate={EndDate}
          isTillDate={endDateDisabled}
          onDataSave={onDataSave}
          modalClosed={props.chartSettingToggleHandler}
        />
      }
      {props.showAddSensorColumnPopup &&
        <AddIAQSensorColumn
          from='LineChart'
          model={model}
          columnSave={onColumnSave}
          modalClosed={props.addSensorColumToggleHandler}
        />
      }

      <div className="icon-nav navbar-fixed-top device-nav-bar text-left">
        <div className="container-fluid">
          <div className="filter-left-area">
            <ul className="dcc-header-list">
              <li className="dcc-header-item">
                <img src={sensorIcon} alt="" className="dcc-header-icon" />
                <h1 className="dcc-header-title">
                  <FormattedMessage id='Sensor_Data_Chart' />
                </h1>
                <span className="dcc-header-separator">|</span>
                <span className="dcc-header-label">
                  <FormattedMessage id='Sensor_Label_ICCID' />:
                </span>
                <span className="dcc-header-value">{" " + iccid}</span>
                <span className="dcc-header-separator">|</span>
              </li>

              <li className="dcc-header-item">
                <span className="dcc-header-label">
                  <FormattedMessage id='Sensor_type' />:
                </span>
                <span className="dcc-header-value">
                  {" "} 
                  <FormattedMessage id={modelEnum.IAQ.toLowerCase()} />
                </span>
                <span className="dcc-header-separator">|</span>
              </li>

              {customerId && (
                <li className="dcc-header-item">
                  <span className="dcc-header-label">
                    <FormattedMessage id='Sensor_Label_CustomerId' />:
                  </span>
                  <span className="dcc-header-value iaq_customer_id" title={customerId}>{" " + customerId}</span>
                  <span className="dcc-header-separator">|</span>
                </li>
              )}

              <li className="dcc-header-item">
                <span className="dcc-header-label">
                  <FormattedMessage id="Duration" />:
                </span>
                <span className="dcc-header-value">
                  {durationInfo.range && <FormattedMessage id={durationInfo.range} />}{" "}
                  ({durationInfo.startDate || "-"} – {durationInfo.endDate || "-"})
                </span>
              </li>
            </ul>
          </div>

          <div className="add-list float-right">
            <ul>
              <li title={formatMessage('Back')}>
                <a data-toggle="modal" onClick={() => backToSensorDataHandler()}>
                  <img src={backIcon} alt="back"></img>
                </a>
              </li>
              <li title={formatMessage('Data_Range')}>
                <a data-toggle="modal" onClick={() => openChartSetting()} data-target="#addSensor">
                  <i className="fa fa-cog"></i>
                </a>
              </li>
              <li title={formatMessage('Select_KPI')}>
                <a data-toggle="modal" onClick={() => openAddColumn()} data-target="#addSensor">
                  <i className="material-icons">view_day</i>
                </a>
              </li>
              <li title={formatMessage('Refresh')}>
                <a data-toggle="modal" onClick={() => refreshChartClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                    <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {(dataRangeFlag || columnListFlag) &&
        <div><p><FormattedMessage id='New_User_Chart_Message' /></p></div>
      }
      <div id="line-chart" className="row">
        {(charts.length === 0 && !dataRangeFlag && !columnListFlag) &&

          [0, 1, 2, 3, 4, 5].map((option: any, i: number) => {
            let kPIs = columnLists.columns !== undefined
              ? (columnLists.columns.Value ? JSON.parse(columnLists.columns.Value) : [])
              : [];
            if (option <= kPIs.length - 1)
              return (
                <div key={i} className="col-sm-6 mb-4 ipadchart">
                  <ChartSkeleton height={260} />
                </div>
              )
          }
          )
        }
        {charts.map((option: any, index: number) => {
          return (
            <div key={`${chartKey}-${index}`} className={charts.length > 1 ? "col-sm-6 mb-4 ipadchart" : "col-sm-12 mb-4"}>
              <div className="kpi-card-iaq">
                <div className="kpi-chart-container  iaq-canvasjs-theme">
                  <LineChart index={index} options={option}></LineChart>
                </div>
              </div>
            </div>
          )
        })}
        {allChartSensorData?.length === 0 &&
          <div className="no-device-wrapper">
            <img src={noData} alt="No Device" className="no-device-img" />
            <h4 className="no-device-title">
              <FormattedMessage id="Message_No_Data_Found" />
            </h4>
          </div>
        }
      </div>
    </React.Fragment>
  );
};

export default injectIntl(IAQChartSettingPopupHOC(AddIAQSensorColumnPopupHOC(IAQSensorDataLineChart)));
